import React, { Component, useRef, useState } from 'react';
import './App.css';
import { Channel, RootState, RoutingResult, setInputConfiguration, updateChannels } from '.';
import { connect, useDispatch, useSelector } from 'react-redux';
import { FormEditor } from './Geometry/FormEditor';
import { SVGEditor } from './SVG/SVGEditor';
import { Button, Container, Form, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { nanoid } from '@reduxjs/toolkit';

const App = () => {

  const s = useSelector((state: RootState) => state.inputConfiguration)
  const dispatch = useDispatch()

  const configurationInput = useRef<HTMLInputElement>(null);

  return (<React.Fragment>
    <Navbar expand="lg">
      <Container fluid>
        <Navbar.Toggle aria-controls="navbar" />
        <Navbar.Brand>
          <h3>Channel Router</h3>
        </Navbar.Brand>
        <Navbar.Collapse id="navbar">
          <Nav>
            <NavDropdown
              id="loadSave"
              title="Load/Save"
            >
              <NavDropdown.Item
                onClick={() => {
                  configurationInput.current?.click()
                }}
              >
                Load Configuration
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  exportConfiguration(s, nanoid())
                }}
              >
                Save Configuration
              </NavDropdown.Item>
              <input
                type="file"
                name="name"
                ref={configurationInput}
                style={{
                  display: 'none'
                }}
                onChange={(e) => {
                  if(e.target.files === null) {
                    return
                  }
                  const file = e.target.files[0];

                  const reader = new FileReader();
                  reader.readAsText(file, 'UTF-8');

                  reader.onload = readerEvent => {
                    if(readerEvent.target === null) {
                      return
                    }
                    const content = readerEvent.target.result as string
                    const config = JSON.parse(content)
                    dispatch(setInputConfiguration(config))
                  }
                }}
              />
            </NavDropdown>
            <NavDropdown
              id="benchmarks"
              title="Benchmark Cases"
            >
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case1.json')
                }}
              >
                Case 1
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case2.json')
                }}
              >
                Case 2
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case3.json')
                }}
              >
                Case 3
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case4.json')
                }}
              >
                Case 4
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case5.json')
                }}
              >
                Case 5
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case6.json')
                }}
              >
                Case 6
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case7.json')
                }}
              >
                Case 7
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case8.json')
                }}
              >
                Case 8
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case9.json')
                }}
              >
                Case 9
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case10.json')
                }}
              >
                Case 10
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case11.json')
                }}
              >
                Case 11
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  downloadFile('benchmarks/case12.json')
                }}
              >
                Case 12
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

    <div className="App">
      <SVGEditor />
      <FormEditor />
    </div>
    <footer 
      className="text-center"
      style={{
        padding: "1em"
      }}
    >
      2022 <a href="https://www.cda.cit.tum.de/">Chair for Design Automation</a>, Technical University of Munich
    </footer>
    </React.Fragment>
    );
}

function exportConfiguration(exportObj: any, exportName: any){
  const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj))
  const downloadAnchorNode = document.createElement('a')
  downloadAnchorNode.setAttribute("href",     dataStr);
  downloadAnchorNode.setAttribute("download", exportName + ".json");
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

function downloadFile(url: string) {
  const a = document.createElement('a')
  a.href = url
  a.download = url.split('/').pop()!
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export default App;
